<style lang="scss">

</style>

<template>
	<div style="overflow: auto;height: 100%;position: relative;display: flex;flex-direction: column;">
		<div class="titleBar"
			style="display: flex;align-items:center ;position: sticky;top: 0;background: #202027;padding: 20px;padding-bottom: 14px;">
			<span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
			<p style="font-size: 16px;line-height: 22px;color: #F4F4F4;">
				{{$t('kajilvzuigao')}}
			</p>
		</div>
    <div v-if="cockpitData.startupRateData.length===0" style="display: flex;justify-content: center;align-items: center;margin-top: 140px">
      <span style="color: #909399;font-size: 16px">{{$t('zanwushuju')}}</span>
    </div>
  <div style="padding: 40px 20px;display: flex;justify-content: space-between;flex: 1;">
    <div v-for="item in cockpitData.startupRateData" style="width:60px;display: flex;flex-direction: column;justify-content: space-between;height: 100%;align-items: center;" >
      <p style="font-size:16px;color:white">{{item.startupRate+'%'}}</p>
      <div style="flex: 1;background: #414A5F;margin: 10px 0px 20px 0px;border-radius: 16px;width:16px;display: flex;align-items: flex-end;position: relative;">
        <div :style="{'height':item.startupRate+'%'}" style="height: 0%;width: 16px;border-radius: 16px;width:16px;;background: linear-gradient(120deg, #C2FFC6 0%, #38D157 100%);;">

        </div>
        <div style="position: absolute;width:22px;height:22px;background: white;border-radius: 50%;bottom: -10px;left: -3px"></div>
      </div>
      <p style="font-size:16px;color:#C0C4CC;text-align: center;height:42px;overflow:hidden">{{item.equipmentName}}</p>
    </div>
  </div>

  </div>

</template>
<script type="text/javascript">
	export default {
		name: 'web_monitor_cockpit_up',
		components: {
			
		},
		props: {
			cockpitData: {
				type: Object,
				default: function() {
					return {}
				},
			},
		},

		data() {
			return {
			};
		},
		created() {
			
		},
		mounted() {
      console.log('cockpitData',this.cockpitData.startupRateData)
			this.resize()
			this.utils.event_hub.$on('RESIZE', () => {
				this.resize();
			});
		},
		watch: {
			
		},
		destroyed() {
			clearInterval(this.timmer)
		},
		methods: {
			
			resize() {
				//因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
				setTimeout(() => {

				}, 500)

			},
		}
	};
</script>
